export { HeadlessClient, createHeadlessClient } from './client.js';

export { CheckoutModule } from './modules/checkout.js';
export { parseTokensFromUrl } from './modules/checkout.js';
export { PaymentModule } from './modules/payment.js';
export { OffersModule } from './modules/offers.js';
export { CustomerModule } from './modules/customer.js';
export { CustomerPortalModule } from './modules/portal/index.js';
export type * as PortalTypes from './modules/portal/types.js';
export { CatalogModule } from './modules/catalog.js';
export { FunnelModule } from './modules/funnel.js';
export { RxModule, isQuestionActive, toIntakeAnswers } from './modules/rx.js';
export { TrackModule } from './modules/track.js';
export type { StepData, EventData, TrackIdentity, TrackHealth } from './modules/track.js';
export type {
  RxCaseStatus,
  RxRequiredForProduct,
  RxStorefrontPatient,
  RxIntakeAnswer,
  RxClinicalQuestion,
  RxClinicalQuestionRule,
  RxQuestionAnswers,
  RxIntakeContext,
  RxIntakeIssue,
  RxValidateIntakeInput,
  RxQuestionsForProduct,
  RxSubmitCaseInput,
  RxSubmitCaseResult,
  RxCaseSummary,
  RxIntakeContextResult,
  RxIntakeContextPatient,
  RxActivationStatus,
  RxActivationStepKey,
  RxActivationMissingItem,
} from './modules/rx.js';

export { HttpClient } from './http.js';

// On-chain crypto (`crypto_onchain`): paid inline from the page, never through pay-v2
export {
  CryptoOnchainCheckout,
  CRYPTO_ONCHAIN_PAYMENT_METHOD,
  CRYPTO_ONCHAIN_STATUS_POLL_MS,
  CRYPTO_ONCHAIN_FINAL_PHASES,
  isCryptoOnchainMethod,
  defaultCryptoOnchainSelection,
  selectCryptoOnchainNetwork,
  cryptoOnchainPhase,
  cryptoOnchainSecondsLeft,
  formatCryptoOnchainCountdown,
} from './helpers/cryptoOnchain.js';
export type { CryptoOnchainApi } from './helpers/cryptoOnchain.js';

export {
  TagadaError,
  TagadaAuthError,
  TagadaValidationError,
  TagadaNotFoundError,
  TagadaRateLimitError,
  TagadaPaymentError,
  TagadaNetworkError,
} from './errors.js';

// Helpers: Google Autocomplete, ISO countries/regions, currency formatting
export {
  GoogleAutocompleteCore,
  loadGoogleMapsScript,
  ISODataCore,
  AVAILABLE_LANGUAGES,
  CurrencyUtils,
  formatMoney,
  ensureGeoDataLoaded,
  getCountries,
  getStatesForCountry,
  isLanguageLoaded,
} from './helpers/index.js';

export type {
  GooglePrediction,
  GooglePlaceDetails,
  ExtractedAddress,
  FormattedAddress,
  SupportedLanguage,
  ISOCountry,
  ISORegion,
  Country,
  State,
  Currency,
} from './helpers/index.js';

export type {
  Environment,
  HeadlessConfig,
  HttpRequestOptions,
  LineItem,
  CreateCheckoutSessionOptions,
  CheckoutCustomerMetadata,
  CheckoutSession,
  CheckoutLineItem,
  CheckoutTotals,
  CheckoutCustomer,
  Address,
  ShippingRate,
  PaymentMethodConfig,
  PaymentSetupConfig,
  ExpressMethod,
  ExpressMethods,
  StoreConfig,
  PayResult,
  PayOptions,
  PayDirectOptions,
  ProcessPaymentOptions,
  ProcessPaymentResult,
  OceanPaymentConfig,
  MountOceanPaymentOptions,
  OceanPaymentForm,
  CryptoOnchainAsset,
  CryptoOnchainNetwork,
  CryptoOnchainPayment,
  CryptoOnchainStatus,
  CryptoOnchainOptionsFailureCode,
  CryptoOnchainPaymentFailureCode,
  CryptoOnchainStatusFailureCode,
  CryptoOnchainFailure,
  CryptoOnchainOptionsResult,
  CryptoOnchainPaymentResult,
  CryptoOnchainStatusResult,
  CryptoOnchainPhase,
  CryptoOnchainSelection,
  CryptoOnchainCheckoutState,
  CryptoOnchainCheckoutOptions,
  CreateInstrumentOptions,
  PaymentInstrument,
  ThreedsSession,
  PaymentStatus,
  Offer,
  OfferLineItem,
  OfferPreview,
  OfferPreviewItem,
  OfferPayResult,
  Customer,
  Order,
  OrderItem,
  Subscription,
  CatalogProduct,
  CatalogVariant,
  CatalogPrice,
  CurrencyOption,
  FunnelNavigateInput,
  FunnelNavigateResult,
} from './types.js';

export { ExperimentsModule } from './modules/experiments.js';
export type { TgdBootstrap, TgdIds } from '../tgd/contract/index.js';
